import {format} from 'date-fns'
import React from 'react'
import {CSVLink} from 'react-csv'

export default function AscosporeMaturitySummary({tableData, csvData}) {
  if (!tableData) return null

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-semibold text-gray-600 md:text-2xl">
          Ascospore Maturity Summary
        </h2>

        <div className="flex justify-center rounded-md shadow-sm">
          <button
            type="button"
            aria-label="download results table data in csv format"
            className="inline-flex items-center p-2 text-sm font-medium leading-4 text-white transition duration-150 ease-in-out border border-transparent rounded-md sm:px-3 sm:py-2 bg-secondary-800 hover:bg-secondary-700 focus:outline-none focus:border-secondary-900 focus:shadow-outline-secondary active:bg-secondary-900"
          >
            <svg
              className="-ml-0.5 mr-2 h-4 w-4"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
            </svg>

            <CSVLink
              className="text-white no-underline"
              filename={`Ascospore Maturity Summary.csv`}
              data={csvData}
            >
              <span className="hidden text-white sm:inline-block">
                Download
              </span>{' '}
              <span className="text-white">CSV</span>
            </CSVLink>
          </button>
        </div>
      </div>

      <div className="flex flex-col my-4 sm:flex-row sm:justify-between sm:items-center">
        <div className="flex flex-col mt-2 text-sm lg:mt-0 lg:items-center lg:flex-row"></div>

        <div className="flex flex-col mt-2 text-sm lg:mt-0 lg:items-center lg:flex-row">
          <span className="mb-2 mr-3 font-bold tracking-wider text-gray-700 lg:mb-0">
            Daily Discharge Thresholds:
          </span>
          <div className="grid grid-cols-2 gap-1">
            <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-md text-xs lg:text-sm font-bold text-yellow-900 bg-yellow-300">
              &ge; 10%
            </span>
            <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-md text-xs lg:text-sm font-bold text-white bg-yellow-800">
              &gt; 20%
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-4">
        <div className="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div className="inline-block min-w-full overflow-hidden overflow-y-auto align-middle border-b border-gray-200 shadow sm:rounded-lg">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="sticky top-0 px-6 py-3 text-xs leading-4 tracking-wider text-center text-white border-r border-gray-200 bg-secondary-800">
                    Date
                  </th>
                  <th className="sticky top-0 px-6 py-3 text-xs leading-4 tracking-wider text-white border-b border-r border-gray-200 bg-secondary-800">
                    Ascospore Maturity
                  </th>
                  <th className="sticky top-0 px-6 py-3 text-xs leading-4 tracking-wider text-white border-b border-r border-gray-200 bg-secondary-800">
                    Daily Ascospore Discharge
                  </th>
                  <th className="px-6 py-3 text-xs leading-4 tracking-wider text-white border-b border-r border-gray-200 bg-secondary-800">
                    Cumulative Ascospore Discharge
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {tableData.map(day => {
                  let daily = null
                  if (day.dailyAscosporeDischarge) {
                    daily = day.dailyAscosporeDischarge.split('%')[0]
                    if (daily !== '<1') daily = parseFloat(daily)
                  }

                  let dailyBg = ''
                  if (daily) {
                    if (daily >= 10) dailyBg = 'text-yellow-900 bg-yellow-300'
                    if (daily > 20) dailyBg = 'text-white bg-red-800'
                  }

                  return (
                    <tr key={day.ms}>
                      <td className={`td py-2`}>
                        <span className={`flex flex-col items-center cell`}>
                          {format(day.date, 'LLL d')}
                          <small className="font-bold text-gray-500">
                            {day.isForecast ? 'Forecast' : ''}
                          </small>
                        </span>
                      </td>

                      <td className={`td py-2`}>
                        <span className={`cell`}>{day.ascosporeMaturity}%</span>
                      </td>

                      <td className={`td py-2`}>
                        <span className={`cell ${dailyBg}`}>
                          {day.dailyAscosporeDischarge}
                        </span>
                      </td>

                      <td className={`td py-2`}>
                        <span className={`cell`}>
                          {day.cumulativeAscosporeDischarge}
                        </span>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
